import {useState} from "react";
import {App as AntdApp} from "antd";
import className from "classnames/bind";
import {FontAwesomeIcon, PageHeader, SearchBar, Button} from "~/components";
import {Link} from "react-router-dom";
import {rtkErrorMessage} from "~/reduxs/api/apiSlice";
import {useAnalyzePsiMutation} from "~/reduxs/api/pagespeedApiSlice";
import PsiResult from "../components/PsiResult";
import style from "../style/PageSpeed.module.scss";

const cn = className.bind(style);

/**
 * Trang công cụ PageSpeed / Core Web Vitals: nhập URL → BE gọi PageSpeed Insights
 * (mobile + desktop) → hiển thị điểm + CWV + cơ hội cải thiện.
 */
function PageSpeed() {

	const {notification} = AntdApp.useApp();

	const [analyzePsi, {isLoading}] = useAnalyzePsiMutation();

	const [result, setResult] = useState(null);

	const handleAnalyze = async (url) => {
		try {
			const data = await analyzePsi(url).unwrap();
			setResult(data);
		} catch (e) {
			notification.error({message: 'Lỗi', description: rtkErrorMessage(e, 'Kiểm tra thất bại')});
		}
	};

	return (
		<div className="container">
			<PageHeader
				icon="fa-light fa-gauge-high"
				title="PageSpeed / Core Web Vitals"
				subtitle="Nhập URL để đo tốc độ tải và chỉ số Core Web Vitals (Google PageSpeed Insights)"
				actions={
					<Button to="/pagespeed/history" white
						leftIcon={<FontAwesomeIcon icon="fa-light fa-clock-rotate-left" />}>
						Lịch sử
					</Button>
				}
			/>

			<SearchBar
				icon="fa-light fa-globe"
				placeholder="Nhập URL, ví dụ: https://sikido.vn"
				buttonText="Kiểm tra"
				buttonIcon="fa-light fa-gauge-high"
				loading={isLoading}
				onSubmit={handleAnalyze}
			/>

			{isLoading && (
				<div className={cn('loading')}>
					<span className="app-spinner" />
					<p>Đang phân tích mobile và desktop, có thể mất 10–40 giây…</p>
				</div>
			)}

			{!isLoading && result && (
				<div className={cn('result-domain')}>
					<FontAwesomeIcon icon="fa-light fa-globe" />
					<span>Kết quả cho <a href={result.url} target="_blank" rel="noreferrer">{result.url}</a></span>
					<Link className={cn('result-link')} to="/pagespeed/history">Xem lịch sử</Link>
				</div>
			)}

			{/* Lần đầu vào trang (chưa đo lần nào) — hướng dẫn thay vì màn trống. */}
			{!isLoading && !result && (
				<div className={cn('first-run')}>
					<FontAwesomeIcon icon="fa-light fa-gauge-high" />
					<h3>Nhập URL để bắt đầu đo</h3>
					<p>Công cụ gọi Google PageSpeed Insights đo cả mobile lẫn desktop (mất 10–40 giây). Bạn sẽ nhận được:</p>
					<ul>
						<li>Điểm Hiệu năng / SEO / Trợ năng / Best practices theo Lighthouse.</li>
						<li>Core Web Vitals: LCP, INP, CLS — kèm dữ liệu người dùng thực (CrUX) nếu trang đủ lượng truy cập.</li>
						<li>Danh sách cơ hội cải thiện xếp theo mức tiết kiệm thời gian tải.</li>
					</ul>
					<p className={cn('first-run-note')}>Kết quả được lưu cache 12 giờ — đo lại cùng URL trong khoảng đó sẽ trả kết quả ngay.</p>
				</div>
			)}

			{!isLoading && <PsiResult result={result} />}
		</div>
	);
}

export default PageSpeed;
